import { isHLApp } from '@fs/utils'
import { checkFreeze } from '../http.tool'

export default (response) => {
  if (isHLApp()) {
    const freezeErrorRes = checkFreeze(response, 'app')
    if (freezeErrorRes) {
      return Promise.reject(freezeErrorRes?.error)
    }
  } else {
    const freezeError = checkFreeze(response)
    if (freezeError) return Promise.reject(freezeError?.error)
  }
  return response
}
